import axios from 'axios';

const rawBaseUrl =
  process.env.REACT_APP_API_URL || `${window.location.origin}/api`;
const baseUrl = rawBaseUrl.endsWith('/api') ? rawBaseUrl : `${rawBaseUrl}/api`;

const handleResponse = (response) => {
  if (response?.data) {
    return response.data;
  }

  return {
    isSuccess: false,
    resultMessage: 'Beklenmeyen cevap alındı.',
  };
};

export async function getLibraries() {
  try {
    const res = await axios.get(`${baseUrl}/library-appointments/libraries`);
    return handleResponse(res);
  } catch (error) {
    console.error('[LibraryAppointment] libraries error', error);
    return {
      isSuccess: false,
      resultMessage: error?.message || 'Kütüphaneler alınamadı.',
    };
  }
}

export async function getLibraryAppointmentSettings(libraryId) {
  try {
    const res = await axios.get(`${baseUrl}/library-appointments/settings`, {
      params: { libraryId },
    });
    return handleResponse(res);
  } catch (error) {
    console.error('[LibraryAppointment] settings error', error);
    return {
      isSuccess: false,
      resultMessage: error?.message || 'Ayarlar alınamadı.',
    };
  }
}

export async function getLibrarySeatAvailability({ appointmentDate, slotStartTime, libraryId }) {
  try {
    const res = await axios.get(`${baseUrl}/library-appointments/availability`, {
      params: { appointmentDate, slotStartTime, libraryId },
    });
    return handleResponse(res);
  } catch (error) {
    console.error('[LibraryAppointment] availability error', error);
    return {
      isSuccess: false,
      resultMessage: error?.message || 'Masa durumu alınamadı.',
    };
  }
}

export async function getBlockedSlots(date, libraryId) {
  try {
    const res = await axios.get(`${baseUrl}/library-appointments/blocked-slots`, {
      params: { date, libraryId },
    });
    return handleResponse(res);
  } catch (error) {
    console.error('[LibraryAppointment] blocked slots error', error);
    return {
      isSuccess: false,
      resultMessage: error?.message || 'Kapalı aralıklar alınamadı.',
    };
  }
}

export async function createLibraryAppointment(payload) {
  try {
    const res = await axios.post(
      `${baseUrl}/library-appointments/request`,
      payload
    );
    return handleResponse(res);
  } catch (error) {
    console.error('[LibraryAppointment] create error', error);
    const message =
      error?.response?.data?.resultMessage ||
      error?.message ||
      'Randevu oluşturulamadı.';
    return {
      isSuccess: false,
      resultMessage: message,
      errors: error?.response?.data?.errors,
    };
  }
}

export async function confirmLibraryAppointment(payload) {
  try {
    const res = await axios.post(
      `${baseUrl}/library-appointments/confirm`,
      payload
    );
    return handleResponse(res);
  } catch (error) {
    console.error('[LibraryAppointment] confirm error', error);
    const message =
      error?.response?.data?.resultMessage ||
      error?.message ||
      'Doğrulama yapılamadı.';
    return {
      isSuccess: false,
      resultMessage: message,
      errors: error?.response?.data?.errors,
      statusCode: error?.response?.status,
    };
  }
}

const arrayBufferToBase64 = (buffer) => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const chunkSize = 0x8000;
  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode.apply(null, chunk);
  }
  return window.btoa(binary);
};

export async function getLibraryAppointmentQr(appointmentCode) {
  if (!appointmentCode) {
    return {
      isSuccess: false,
      resultMessage: 'Geçerli bir randevu kodu bulunamadı.',
    };
  }

  try {
    const encodedCode = encodeURIComponent(appointmentCode);
    const res = await axios.get(
      `${baseUrl}/library-appointments/${encodedCode}/qr`,
      {
        responseType: 'arraybuffer',
      }
    );

    const contentType = res.headers['content-type'] || 'image/png';
    const base64 = arrayBufferToBase64(res.data);

    return {
      isSuccess: true,
      dataUrl: `data:${contentType};base64,${base64}`,
    };
  } catch (error) {
    console.error('[LibraryAppointment] qr error', error);
    const message =
      error?.response?.data?.resultMessage ||
      error?.message ||
      'QR kodu alınamadı.';
    return {
      isSuccess: false,
      resultMessage: message,
    };
  }
}

export async function cancelLibraryAppointmentByToken(token) {
  try {
    const res = await axios.post(`${baseUrl}/library-appointments/cancel-by-token`, { token });
    return handleResponse(res);
  } catch (error) {
    console.error('[LibraryAppointment] cancel error', error);
    const message =
      error?.response?.data?.resultMessage ||
      error?.message ||
      'Randevu iptal edilemedi.';
    return {
      isSuccess: false,
      resultMessage: message,
    };
  }
}

export async function getConfirmedAppointmentsByUser(identityNumber) {
  try {
    const res = await axios.get(`${baseUrl}/library-appointments/confirmed-by-user`, {
      params: { identityNumber }
    });
    return handleResponse(res);
  } catch (error) {
    console.error('[LibraryAppointment] getConfirmed error', error);
    const message =
      error?.response?.data?.resultMessage ||
      error?.message ||
      'Randevular alınamadı.';
    return {
      isSuccess: false,
      resultMessage: message,
    };
  }
}

export async function sendCancellationCode(appointmentId) {
  try {
    const res = await axios.post(`${baseUrl}/library-appointments/send-cancellation-code`, { appointmentId });
    return handleResponse(res);
  } catch (error) {
    console.error('[LibraryAppointment] sendCode error', error);
    const message =
      error?.response?.data?.resultMessage ||
      error?.message ||
      'Kod gönderilemedi.';
    return {
      isSuccess: false,
      resultMessage: message,
    };
  }
}

export async function cancelLibraryAppointmentByCode(appointmentId, verificationCode) {
  try {
    const res = await axios.post(`${baseUrl}/library-appointments/cancel-by-code`, { appointmentId, verificationCode });
    return handleResponse(res);
  } catch (error) {
    console.error('[LibraryAppointment] cancelByCode error', error);
    const message =
      error?.response?.data?.resultMessage ||
      error?.message ||
      'İptal işlemi başarısız.';
    return {
      isSuccess: false,
      resultMessage: message,
    };
  }
}

